import type {CanvasRect} from '@PosterWhiteboard/collaboration/poster-presence.types';

export interface PagePresenceLayerProps {
  pageId: string;
}

/**
 * The one box drawn around a session's whole selection, in the page's unscaled canvas pixels; the
 * layer multiplies by the page zoom and turns the box about its centre by `angle`, as this editor's
 * own selection box turns.
 */
export interface RemoteSelectionOutline extends CanvasRect {
  angle: number;
}

export const FULL_TURN_DEGREES = 360;

/** Turned further than a quarter turn either way, a name pill fixed to the outline's top-left corner would read upside down. */
export const NAME_PILL_FLIP_FROM_DEGREES = 90;
export const NAME_PILL_FLIP_UNTIL_DEGREES = 270;
